import type { FunctionComponent } from 'react';
import React from 'react';

import { Spinner } from '@trello/nachos/spinner';

import styles from './CardDetailLoading.less';

export const CardDetailLoading: FunctionComponent = () => (
  <div className={`${styles.cardDetailLoading}`}>
    <Spinner centered={true} />
  </div>
);
